import { EMBEDDED_VENDOR } from 'portal-modules/common/constants/keys'

export const getEmbeddedVendorName = () =>
  window?.rpSettings?.vendor || sessionStorage.getItem(EMBEDDED_VENDOR) || ''
